<!-- eslint-disable vue/no-multiple-template-root -->
 <!--Designed & Developed by:
    Nirmal K (@cyberwizard1001)⁶
    Nitin Ravi (@nitinravi)
    Ritwik M (@ritwik-m) &
    Nalinadevi K 
 for the Ministry of Education (MOE) virtual-labs project, Govt.OfIndia-->

<script>

import router from '@/router'
import { ref } from 'vue'
export default {
  setup() {
    const items = ref([
    { id: 5, alpha: ' ', order: 4, content: 'The Office executive then marks the contract active by entering the vehicle release data (today\'s date) onto the vehicle reservation contract.', list: 1 },
      { id: 0, alpha: ' ', order: 5, content: 'A customer comes to the office to acquire a vehicle', list: 1 },
      { id: 4, alpha: ' ', order: 2, content: 'The customer signs the contract and the Office executive gives the keys to the vehicle.', list: 1 },
      { id: 2, alpha: ' ', order: 1, content: 'The use case terminates at ths point.', list: 1 },
      { id: 6, alpha: ' ', order: 3, content: 'The Office executive locates the vehicle reservation contract by means of the reservation number and/or customer name. [Exception: Required vehicle type is not available due to late arrivals.]', list: 1 },
    ])

    const getList = (list) => {
      return items.value.filter((item) => item.list === list)
    }

    const startDrag = (event, item) => {
      console.log(item)
      event.dataTransfer.setData('itemID', item.id)
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.dropEffect = 'move'
    }

    const onDrop = (event, list) => {
      event.preventDefault()
      const itemID = event.dataTransfer.getData('itemID')
      const item = items.value.find((item) => item.id === parseInt(itemID))
      item.list = list
    }

    return {
      getList,
      startDrag,
      onDrop
    }
  },
  methods: {
    popup() {
            var modal = document.getElementById("myModal");

            // Get the button that opens the modal
            var btn = document.getElementById("myBtn");

            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("close")[0];

            // When the user clicks the button, open the modal 
            btn.onclick = function () {
                modal.style.display = "block";
            }

            // When the user clicks on <span> (x), close the modal
            span.onclick = function () {
                modal.style.display = "none";
            }

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                }
            }
        },

    incorrect() {
      var x = document.getElementById("snackbar");
      x.innerHTML = "Please drag all the sentences into the timeline";
      x.style.backgroundColor = "red";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000)
    },
    nextClick(){
      router.push('/anim-two')
    },
    validate() {
      let final_list = []

      for(let i=0;i<5;i++){
        this.valid[i] = false
      }

      this.validated = true;
      // let i = 0
      for (let i = 2; i < 7; i++) {
        console.log(this.getList(i))
        if(this.getList(i).length==0){
          this.incorrect();
          this.validated=false;
          return
        }
        final_list.push(this.getList(i))
      }
      console.log(final_list)
      console.log(final_list.length)

      if(final_list.length!=5){
        this.incorrect();
        this.validated=false;
        return
      }

      if(final_list[0][0].id == 0){
        this.valid[0] = true
      }

      else{
        this.valid[0] = false
      }

      if(final_list[1][0].id == 6){
        this.valid[1] = true
      }

      else{
        this.valid[1] = false
      }

      if(final_list[2][0].id == 4){
        this.valid[2] = true
      }

      else{
        this.valid[2] = false
      }

      if(final_list[3][0].id == 5){
        this.valid[3] = true
      }

      else{
        this.valid[3] = false
      }

      if(final_list[4][0].id == 2){
        this.valid[4] = true
      }

      else{
        this.valid[4] = false
      }

      if(this.valid[0] && this.valid[1] && this.valid[2] && this.valid[3] && this.valid[4]){
        this.verified = true;
        var x = document.getElementById("snackbar");
      x.innerHTML = "Correct";
      x.style.backgroundColor = "green";
      x.className = "show";
      }

      else{
        
      x.innerHTML = "Incorrect. Try again";
      x.style.backgroundColor = "red";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000)
      }

    },
  },
  data() {
    return {
      valid: [false,false,false,false,false],
      validated: false,
      verified: false,
    }
  }
}
</script>

<template class="app">
  <header style="padding: 20px; display: flex; flex-direction: row; align-items: center; justify-content: space-between;">
    <div>
    <h1>Step 1: Identifying the correct sequence of actions</h1>
    <p>To map a real life scenario to code, it has to be listed in sequence. Drag and drop the sentences listed below
      onto the blanks in the timeline given below to continue.</p>
    </div>
      <button id="myBtn" style="align-self: flex-end, margin-right: 20px;" @click="popup()" class="button-30">Help</button>
  </header>
  

  <main>
    <div id="snackbar">Some text some message..</div>
    <div id="myModal" class="modal">

<!-- Modal content -->
<div class="modal-content">
    <span class="close">&times;</span>
    <p style="padding: 25px;">The following is a demonstration of the interactivity.</p>
    <img src="..\assets\exp1s1.gif" style="height: 500px;">
</div>


</div>

    <div class="flex-parent">
      <div class="flexbox">
        <div class="drop-zone" @drop="onDrop($event, 1)" @dragenter.prevent @dragover.prevent>
          <div v-for="item in getList(1)" :key="item.order" class="drag-el" draggable="true"
            @dragstart="startDrag($event, item)">
            <div class="aplha unidentified">
              <h3>{{ item.alpha }}</h3>
            </div>
            <div class="cardtext">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="flexbox">
        <div class="drop-zone-single" @drop="onDrop($event, 2)" @dragenter.prevent @dragover.prevent>
          <div v-for="item in getList(2)" :key="item.alpha" class="drag-el" draggable="true" id="1-box"
            @dragstart="startDrag($event, item)">
            <div class="aplha" :class="{ alphaCorrect: (validated && valid[0]), alphainCorrect: (validated && !valid[0]), unidentified: !validated }">
              <h3>{{ item.alpha }}</h3>
            </div>
            <div class="cardtext" :class="{ textCorrect: (validated && valid[0]), textIncorrect: (validated && !valid[0]), unidentified: !validated }">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
        <div class="drop-zone-single" @drop="onDrop($event, 3)" @dragenter.prevent @dragover.prevent>
          <div v-for="item in getList(3)" :key="item.alpha" class="drag-el" draggable="true" id="2-box"
            @dragstart="startDrag($event, item)">
            <div class="aplha" :class="{ alphaCorrect: (validated && valid[1]), alphainCorrect: (validated && !valid[1]), unidentified: !validated }">
              <h3>{{ item.alpha }}</h3>
            </div>
            <div class="cardtext" :class="{ textCorrect: (validated && valid[1]), textIncorrect: (validated && !valid[1]), unidentified: !validated }">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
        <div class="drop-zone-single" @drop="onDrop($event, 4)" @dragenter.prevent @dragover.prevent>
          <div v-for="item in getList(4)" :key="item.alpha" class="drag-el" draggable="true" id="3-box"
            @dragstart="startDrag($event, item)">
            <div class="aplha" :class="{ alphaCorrect: (validated && valid[2]), alphainCorrect: (validated && !valid[2]), unidentified: !validated }">
              <h3>{{ item.alpha }}</h3>
            </div>
            <div class="cardtext" :class="{ textCorrect: (validated && valid[2]), textIncorrect: (validated && !valid[2]), unidentified: !validated }">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
        <div class="drop-zone-single" @drop="onDrop($event, 5)" @dragenter.prevent @dragover.prevent>
          <div v-for="item in getList(5)" :key="item.alpha" class="drag-el" draggable="true" id="4-box"
            @dragstart="startDrag($event, item)">
            <div class="aplha" :class="{ alphaCorrect: (validated && valid[3]), alphainCorrect: (validated && !valid[3]), unidentified: !validated }">
              <h3>{{ item.alpha }}</h3>
            </div>
            <div class="cardtext" :class="{ textCorrect: (validated && valid[3]), textIncorrect: (validated && !valid[3]), unidentified: !validated }">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
        <div class="drop-zone-single" @drop="onDrop($event, 6)" @dragenter.prevent @dragover.prevent>
          <div v-for="item in getList(6)" :key="item.alpha" class="drag-el" draggable="true" id="5-box"
            @dragstart="startDrag($event, item)">
            <div class="aplha" :class="{ alphaCorrect: (validated && valid[4]), alphainCorrect: (validated && !valid[4]), unidentified: !validated }">
              <h3>{{ item.alpha }}</h3>
            </div>
            <div class="cardtext" :class="{ textCorrect: (validated && valid[4]), textIncorrect: (validated && !valid[4]), unidentified: !validated }">
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
  <!--eslint-disable-next-line vue/no-multiple-template-root-->
  <footer>
    <div id="buttons" class="relative">
      <button class="navitem" @click="validate()" v-if="!verified">Validate</button>
      <button class="navitem" @click="nextClick()" v-if="verified">Next</button>
    </div>
  </footer>
</template>

<style scoped>
.drop-zone {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: fit-content;
  max-width: 650px;
  margin: 5px;
  min-height: 80vh;
  background-color: #F9FAFE;
  box-shadow: 2px 3px 10px 2px #D7DFFF;
  border-radius: 10px;
  padding: 10px;
}

.drop-zone-single {
  min-width: 500px;
  /* max-width: 650px; */
  margin: 10px;
  min-height: 10vh;
  max-height: fit-content;
  background-color: #F9FAFE;
  box-shadow: 2px 3px 10px 2px #D7DFFF;
  border-radius: 10px;
  padding: 10px;
}

.drag-el {
  padding: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  position: relative;
}

.drag-el .aplha {
  width: 20px;
  height: 60px;
  position: relative;
  top: 0;
  right: 20;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 5px;
  color: white;
  z-index: 66;
}


.textIncorrect{
  color: #CB3434;
  border: #CB3434 1px solid;
}

.drag-el .cardtext {
  width: 100%;
  position: relative;
  left: 0px;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 2px 3px 10px 2px #D7DFFF;
  background-color: #fff;
}


.textCorrect{
  border: solid 1px #098248;
  color: #098248;
}

.unidentified{
  background-color: #6D71FA;
}

.alphaCorrect{
  background-color: #098248;
}

.alphainCorrect{
  background-color: #CB3434;
}


.flex-parent {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  margin: 10px;
}

.flexbox {
  display: flex;
  flex-direction: column;

  height: 100%;
  width: 100%;
  flex-wrap: wrap;
  min-width: 100px;

  overflow: hidden;

  margin: 0 10;
  padding: 15px
}

#buttons {
  margin: 0;
  text-align: center;
}

.relative {
  padding: 10px;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  background-color: #fff;
}

.navitem {
  width: 100px;
  height: 50px;
  padding: 10px;
  text-align: center;
  border: none;
  background-color: #272971;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  font-weight: normal;
  font-size: large;
}

.navitem:hover {
  background-color: #fff;
  color: #272971;
  border: 1px solid #272971;
  cursor: pointer;
  font-weight: bold;
}

#snackbar {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
  font-size: 17px;
}

#snackbar.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }

  to {
    bottom: 30px;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }

  to {
    bottom: 30px;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }

  to {
    bottom: 0;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }

  to {
    bottom: 0;
    opacity: 0;
  }
}

.button-30 {
    align-items: center;
    appearance: none;
    background-color: #FCFCFD;
    border-radius: 4px;
    border-width: 0;
    box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
    box-sizing: border-box;
    color: #36395A;
    cursor: pointer;
    display: inline-flex;
    font-family: "JetBrains Mono", monospace;
    height: 48px;
    justify-content: center;
    line-height: 1;
    list-style: none;
    overflow: hidden;
    padding-left: 16px;
    padding-right: 16px;
    position: relative;
    text-align: left;
    text-decoration: none;
    transition: box-shadow .15s, transform .15s;
    user-select: none;
    -webkit-user-select: none;
    touch-action: manipulation;
    white-space: nowrap;
    will-change: box-shadow, transform;
    font-size: 18px;
}

.button-30:focus {
    box-shadow: #D6D6E7 0 0 0 1.5px inset, rgba(45, 35, 66, 0.4) 0 2px 4px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
}

.button-30:hover {
    box-shadow: rgba(45, 35, 66, 0.4) 0 4px 8px, rgba(45, 35, 66, 0.3) 0 7px 13px -3px, #D6D6E7 0 -3px 0 inset;
    transform: translateY(-2px);
}

.button-30:active {
    box-shadow: #D6D6E7 0 3px 7px inset;
    transform: translateY(2px);
}

.modal {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    padding-top: 100px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4);
    /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
}

/* The Close Button */
.close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}
</style>
